import { render } from "./WebsiteLayout.vue?vue&type=template&id=77741d1f"
import script from "./WebsiteLayout.vue?vue&type=script&lang=js"
export * from "./WebsiteLayout.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__